// src/components/Layout.jsx
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../pages/Footer';

const Layout = ({ children }) => {
    return (
        <div className="min-h-screen">
            <Navbar />
            <main>{children}</main>
            <Footer />
        </div>
    );
};

export default Layout;
